import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../tooltip'
export const PremiumFlag = (props) => {
  const {itemresult,textmode} = props
  const renderFlag = () => {
    return (<div className={`of-premium-flag${textmode?' of-premium-flag--textmode':''}`}>
      <Tooltip className={"of-premium-flag__tooltip"} button={<div className={"of-premium-flag__wrapper"}>Premium</div>} description={"We offer Premium domains via our registry partners. Premium domain names are usually valued higher because they are brandable keywords, short in length, and/or dictionary words."}/>
    </div>)
  }
  if(itemresult && ( itemresult.premium || itemresult.is_premium)){
    return (renderFlag())
  }
  return (<></>)
}

PremiumFlag.propTypes = {
  itemresult :PropTypes.object,
  textmode: PropTypes.bool
}

export default PremiumFlag